import GetAppIcon from '@mui/icons-material/GetApp'
import TextButton from '../TextButton'

export default function ExportButton({onClick}){

    return(
        <TextButton startIcon={<GetAppIcon />} clickHandler={onClick}>Export File</TextButton>
    );
}
